import { ThrottleStore } from "./ThrottleStore.js";
import { AsyncStorageController } from '@ciaopeople/cp-shatsu/Storage';
import { isNumber } from "@ciaopeople/cp-shatsu/TypeChecking";
export class ThrottleAsyncStorageStoreImpl implements ThrottleStore {

    
    constructor(private readonly propName: string, private readonly storage: AsyncStorageController<string>) {

    }


    store(value: number): Promise<void> {
        return this.storage.setStoredData(this.propName, value).
            then(_x => null).catch(_e => Promise.resolve(null));
    }
    retrieve(): Promise<number> {
        return this.storage.getStoredData(this.propName).then(
            v => {
                if (isNumber(v)) {
                    return v;
                }
                else {
                    return 0;
                }
            }
        ).catch(_e => {
            return Promise.resolve(0);
        });
    }




}